<script setup lang="ts">
import { variantTextColorClassKey } from "./Alert.vue"

const variantTextColorClass = inject(variantTextColorClassKey)
</script>

<template>
  <div :class="`mt-px inline-flex size-4.5 ${variantTextColorClass}`">
    <slot />
  </div>
</template>
